// contact as sent to the backend: nameFriendly from first and last name
export function toContactData(contact = {}) {
  const nameFriendly = [contact.nameFirst, contact.nameLast]
    .filter(name => name && name.trim())
    .join(' ').trim();
  return {
    nameFriendly,
    nameFirst: contact.nameFirst || '',
    nameLast: contact.nameLast || '',
    titleBefore: contact.titleBefore || '',
    titleAfter: contact.titleAfter || '',
    salutation: contact.salutation || 'NONE',
    emailAddress: contact.emailAddress || '',
    phoneNumber: contact.phoneNumber || '',
    description: contact.description || '',
  };
}
